<p-dropdown
  #dropdownRef
  class="select-box-container"
  [id]="id"
  [filter]="false"
  [autoOptionFocus]="false"
  appendTo="body"
  [options]="normalizedOptions"
  [(ngModel)]="selectedValue"
  optionLabel="name"
  optionValue="value"
  [disabled]="disabled"
  placeholder=""
  [panelStyle]="panelStyleValue"
  (onClick)="onDropdownClick()"
  (onChange)="onChangeValue($event.value)"
  (onShow)="onDropdownShow()"
>
</p-dropdown>
